import React from 'react';
import { Navigate } from 'react-router-dom';
import useAuthStore from '../../store/authStore';

const ProtectedRoute = ({ children, ruoliConsentiti = [] }) => {
  const { isAuthenticated, utente } = useAuthStore();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (ruoliConsentiti.length > 0 && !ruoliConsentiti.includes(utente?.ruolo)) {
    return <Navigate to="/non-autorizzato" replace />;
  }

  if (utente?.ruolo === 'UTENTE' && utente?.titolare && !utente.titolare.primo_accesso_completato) {
    return <Navigate to="/primo-accesso" replace />;
  }

  return children;
};

export default ProtectedRoute;

